/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 * @date  2018/6/5 11:16
 * @des
 */

/**
 * 对象属性是否相等
 * @param a obja
 * @param b objb
 * @returns {boolean}
 */
export function isObjectValueEqual (a, b) {
  return JSON.stringify(a) === JSON.stringify(b)
}

export function isString (obj) {
  return typeof (obj) === 'string'
}

export function isNonNullString (str) {
  return typeof (str) === 'string' && str.length > 0
}

export function isNonEmptyArray (obj = []) {
  return obj && obj.length > 0 && Array.isArray(obj) && typeof obj !== 'undefined'
}

export function isObject (item) {
  return (item && typeof item === 'object' && !Array.isArray(item))
}

export function isEmptyObject (obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

export function isNull (obj) {
  return obj == null || typeof obj == 'undefined'
}

export function isArray (item) {
  return (item && Array.isArray(item))
}

//对象浅拷贝
export function objCopy (obj1) {
  var obj2 = {}
  for (var i in obj1) {
    obj2[i] = obj1[i]
  }
  return obj2
}

/**
 * value不为null和undefined
 * @param value
 * @returns {boolean}
 */
export function isValueExist (value) {
  return value !== null && value !== undefined
}

/**
 * value不为null和undefined时设置obj的key为value
 * @param key
 * @param value
 * @param obj
 */
export function setObjKvExist (obj, key, value) {
  if (isObject(obj) && isValueExist(value)) {
    obj[key] = value
  }
}



// WEBPACK FOOTER //
// ./src/base/util/objutil.js